import React from 'react';
import { StyledMoreMenu } from './MoreMenu.styles';

const MoreMenu = props => {
  const { ...rest } = props;
  return <StyledMoreMenu {...rest} />;
};

export default MoreMenu;
